import styled from 'styled-components';

interface IStyledBalanceProps {
  balanceFontSize?: number;
  balanceWeight?: number;
  balanceColor?: string;
}

export const StyledBalance = styled.div<IStyledBalanceProps>`
  font-family: var(--font-family), Arial;
  display: flex;
  align-items: center;
  padding: 2px 4px 2px 0;
  margin-right: 8px;
  margin-top: 4px;
  margin-bottom: 4px;

  .balance-image {
    width: 20px;
    height: 20px;

    .image {
      width: 20px;
      height: 20px;
    }
  }

  .balance-amount {
    margin-left: 2px;
    font-size: ${({ balanceFontSize }) => `${balanceFontSize}px`};
    font-weight: ${({ balanceWeight }) => balanceWeight};
    color: ${({ balanceColor }) => balanceColor};
  }

  &.playdog {
    .balance-amount {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      margin-left: 4px;
      color: inherit;
    }

    &:first-child {
      color: #f2fc48;
    }

    &:last-child {
      color: #5dd0ff;
    }
  }

  &.bagelcode {
    padding: 4px 8px;
    background: rgb(9, 5, 53);
    border: 1px solid rgb(84, 66, 195);
    border-radius: 16px;

    .balance-image {
      width: 16px;
      height: 16px;

      .image {
        width: 16px;
        height: 16px;
      }
    }
  }

  &.ghost {
    color: rgb(255, 226, 35);
    background: rgb(0, 0, 0);
    border-radius: 16px;
    border: 1px solid rgb(103, 1, 225);
    padding-right: 6px;
    height: 16px;

    .balance-image {
      width: 15px;
      height: 15px;
      max-width: 15px;
      margin-right: 2px;

      .image {
        height: auto;
        width: 100%;
        object-fit: contain;
      }
    }
  }

  &.bingo-pop {
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.3);
    height: 24px;
    min-width: 84px;
    margin-left: 12px;
    font-size: 14px;

    .balance-amount {
      display: flex;
      justify-content: center;
      width: 100%;
      color: #fff;
      text-shadow: 2px 2px 0 #1b4883;
      font-weight: 400;
      padding: 0 20px;
    }

    .balance-image {
      position: absolute;
      justify-self: start;
      left: -12px;
      width: 28px;
      height: 28px;
    }

    .image {
      width: 100%;
      height: 100%;
    }
  }

  &.deca {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #fff;
    margin-top: 4px;
    margin-bottom: 0;

    .balance-amount {
      margin-left: 4px;
    }

    .balance-image {
      width: 24px;
      height: 24px;

      .image {
        width: 24px;
        height: 24px;
      }
    }
  }
`;
